export default __webpack_public_path__ + "static/media/move.15f3780a.svg";